import BrowserStorage from '@common/utils/storage/BrowserStorage';

const storageManager = new BrowserStorage(localStorage, 'SW');

export default {
  getItem: <T>(key: string): T | null => storageManager.getItem(key),
  saveItem: <T>(key: string, value: T): boolean => storageManager.saveItem(key, value),
  removeItem: (key: string): boolean => storageManager.removeItem(key),
  unPrefixKey: (key: string | null) => storageManager.unPrefixKey(key),
};
